/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 29.06.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { FlagComponent, DataUtil } from 'plugin/liferay-widgets-react-web'
import {Button} from 'external/react-bootstrap';

import '../css/_miniwidgets.scss';
import ModalActions from '../actions/ModalActions';
import Icon from './Icon';
import DateTimeDisplay from './DateTimeDisplay';

//ToDo FLIWAS-1713: @t.wahl Remove the inline scss and set correct classes or inline-style

let getOverallStateClassName = function (item, className) {
    if (!className) {
        const i = DataUtil.asItem(item);
        return ((i && i.overallState && i.overallState.state.style) || 'lightgrey');
    }
    return className;
};
const MiniWidgetWrapper = ({ item, children, className }) => {
    return (
        <div className={'mini-widget inner ' + getOverallStateClassName(item, className)}>
            <div className="mini-widget-header"> </div>
            <FlagComponent item={item}>
                {children}
            </FlagComponent>
        </div>
    )
};

const MiniWidgetContent = ({ item, children, className }) => {
    return (
        <div className={'content ' + getOverallStateClassName(item, className) }>
            {children}
        </div>
    )
};

// eslint-disable-next-line react/prop-types
const MiniWidgetLineWrapper = ( {onClick, children, className = ""}) => {
    return (
        <div className={`line ${className}`} onClick={ onClick }>
            {children}
        </div>);
};
                                                                                                             
// eslint-disable-next-line react/prop-types
const MiniWidgetLine = ({ iconClass, value, unit, timestamp, onClick, fastEditFunc }) => {

    const _onClickEdit = (e) => {
        e.stopPropagation();
        fastEditFunc();
    }

    return (
        <MiniWidgetLineWrapper onClick={onClick} className="w-100">
            <div className="line-inner">
                <div className="edit-button-wrapper">
                    <div className="d-flex align-items-center">
                        { iconClass && <Icon name={iconClass}/>}
                        <span className="value">{ value }</span>
                        { unit && <span className="unit">{unit}</span>}
                    </div>
                    {
                        fastEditFunc &&
                        <Button
                            variant="outline-primary"
                            className="mini-widget-edit-button"
                            title="Bearbeiten"
                            onClick={_onClickEdit}
                        >
                            <Icon name="pencil" className="mini-widget-edit-icon" title="Bearbeiten"/>
                        </Button>
                    }
                </div>
            </div>
            { timestamp && <DateTimeDisplay timestamp={timestamp} classNames="time"/>}
        </MiniWidgetLineWrapper>
    )
};


class MiniWidgetHeader extends React.Component {

    openHistory() {
        const item = DataUtil.asItem(this.props.item);

        ModalActions.showModal(this.props.className, {
            id: item[ this.props.idAttribute || 'id' ]
        }, false, this.props.props, {
            contextId: this.context && this.context.contextId
        });
    }

    render() {
        return (
            <div className="header" onClick={this.openHistory.bind(this)} title="Details anzeigen">
                <div className="header-icon">
                    <Icon name={this.props.iconClass}/>
                </div>
                <h2><span>{this.props.customTitle || (this.props.item && this.props.item.title)}</span></h2>
            </div>
        );
    }
}

MiniWidgetHeader.propTypes = {
    item: PropTypes.object,
    idAttribute: PropTypes.string,
    customTitle: PropTypes.string,
    iconClass: PropTypes.string,
    className: PropTypes.string,
    contextId: PropTypes.string,
    props: PropTypes.object,
};


MiniWidgetHeader.contextTypes = {
    contextId: PropTypes.string
};

MiniWidgetWrapper.propTypes = {
    item: PropTypes.object,
    children: PropTypes.node,
    className: PropTypes.string
};

MiniWidgetContent.propTypes = {
    item: PropTypes.object,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    className: PropTypes.string
};

export { MiniWidgetWrapper, MiniWidgetContent, MiniWidgetHeader, MiniWidgetLine, MiniWidgetLineWrapper };



// WEBPACK FOOTER //
// ./js/components/MiniWidgetComponents.jsx